<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="blk1">
                       <img src="./image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                       <div class="blkps">
                       <div class="blkrect"></div>
                       <div class="txtku1">资产类型</div>
                       <div class="txtku2">软件资产</div>
                      </div>
                    </div>
                    <div class="engSty1">
                        <div class="engSty" style="position:relative" v-for="(item,index) in m_item" :key="index" @click="tDetail(item)">
                              <div class="tSty1">{{item.dictValue}}</div>
							  <div class="uRect" v-if="item.dictNum>0">{{item.dictNum}}</div>
							  
                        </div>
                    </div>
                </div>

            </div>
        </div>
     </div>


</template>
<script>
    import PJXQ from '@/components/pjxq.vue'
    export default{
        components:{PJXQ},
        data(){
            return {
                dInfo:'',
                m_item:[
				],
            }
        },
        methods:{
            tDetail(item){
				this.$router.push({path:'/rcapital',query:{dictId:item.dictId}})
            },
			getAssets(){
				let data={dictType:5,companyId:0}
				this.$api.get('/app/corporateassets/selectConfig',{params:data}).then(res=>{
					this.m_item=res.data.data
					if(this.$store.state.user.userInfo.role==1){
						let data={supportType:2,companyId:this.$store.state.user.userInfo.companyId}
						this.$api.get('/app/corporateassets/selectConfigCount',{params:data}).then(res=>{
							let datas=res.data.data
							datas.forEach(item=>{
								this.m_item.forEach(item1=>{
									if(item.assetsTypeId==item1.dictId){
										item1.dictNum=item.assetsCount
									}
								})
							})
							this.m_item.forEach(item=>{
								if(item.dictNum==null){
									item.dictNum=0
								}
							})
							this.m_item.sort((a,b)=>{
								return b.dictNum-a.dictNum
							})
						})
					}else{
						let data={supportType:2,userId:this.$store.state.user.userInfo.userId,companyId:this.$store.state.user.userInfo.companyId}
						this.$api.get('/app/corporateassets/selectConfigCount',{params:data}).then(res=>{
							let datas=res.data.data
							datas.forEach(item=>{
								this.m_item.forEach(item1=>{
									if(item.assetsTypeId==item1.dictId){
										item1.dictNum=item.assetsCount
									}
								})
							})
							this.m_item.forEach(item=>{
								if(item.dictNum==null){
									item.dictNum=0
								}
							})
							this.m_item.sort((a,b)=>{
								return b.dictNum-a.dictNum
							})
						})
					}
				})
			},
			// getCount(){
			// 	if(this.$store.state.user.userInfo.role==1){
			// 		let data={supportType:2,companyId:this.$store.state.user.userInfo.companyId}
			// 		this.$api.get('/app/corporateassets/selectConfigCount',{params:data}).then(res=>{
			// 			let datas=res.data.data
			// 			datas.forEach(item=>{
			// 				this.m_item.forEach(item1=>{
			// 					if(item.assetsTypeId==item1.dictId){
			// 						item1.dictNum=item.assetsCount
			// 					}
			// 				})
			// 			})
			// 			this.m_item.forEach(item=>{
			// 				if(item.dictNum==null){
			// 					item.dictNum=0
			// 				}
			// 			})
			// 			this.m_item.sort((a,b)=>{
			// 				return b.dictNum-a.dictNum
			// 			})
			// 		})
			// 	}else{
			// 		let data={supportType:2,userId:this.$store.state.user.userInfo.userId,companyId:this.$store.state.user.userInfo.companyId}
			// 		this.$api.get('/app/corporateassets/selectConfigCount',{params:data}).then(res=>{
			// 			let datas=res.data.data
			// 			datas.forEach(item=>{
			// 				this.m_item.forEach(item1=>{
			// 					if(item.assetsTypeId==item1.dictId){
			// 						item1.dictNum=item.assetsCount
			// 					}
			// 				})
			// 			})
			// 			this.m_item.forEach(item=>{
			// 				if(item.dictNum==null){
			// 					item.dictNum=0
			// 				}
			// 			})
			// 			this.m_item.sort((a,b)=>{
			// 				return b.dictNum-a.dictNum
			// 			})
			// 		})
			// 	}
			// }
        },
        created(){
            this.getAssets()
			// this.getCount()
        },
		mounted(){
		}
    }

</script>
<style scoped>
     .wrap{
            position: absolute;
            top: 0;
            left:0;
            width:100%;
            height:100%;
            z-index:1000;
            overflow: auto;
            background:#e9eef2;
			overflow-x:hidden;
        }
        .wrap_inner{
             min-height: 100%;
             width:100%;
        }
        .wrap_main{
            padding-bottom: 20px;
        }
    .mainlist{
        width:100%;
        height:340px;
    }
    .img1{
        width:25px;
        height:25px;
    }
    .blk1{
        position:relative;
        width: 100%;
        height: 148px;
    }
    .txt1{
        font-size:16px;
        margin-left:16px;
        color:#333
    }
    .nData{
        width:100%;
        height:200px;
        display:flex;
        justify-content:center;
        align-items:center;
        font-size:14px;
    }
    .field1{
        width:100%;
        height:35px;
        line-height:35px;
        padding:0;
    }
	.engSty1{
		margin-top:20px;
		margin-bottom:20px;
	}
    .engSty{
		display: flex;
        width: 309px;
        height: 30px;
		line-height:30px;
        padding:18px 12px;
        margin:8px auto;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:16px;
    }
        .notice{
            display:flex;
            width: 90%px;
            height: 35px;
            padding:0 5%;
            margin:0px auto;
            background: #ffffff;
            border-radius: 4px;
            box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
            font-size:12px;
            align-items:center;
            justify-content:center;
        }
        .notice>div{
            flex:1;
        }
        .notice>div:nth-child(1){
            flex:0 0 19px;
        }
        .notice>div:nth-child(3){
            flex:0 0 22px;
        }
        .tSty{
			flex:0 0 50px;
        }
		.tSty1{
			flex:1;
			overflow:hidden;
			text-overflow:ellipsis;
			white-space:nowrap;
			text-align:center;
		    font-size: 20px;
		    font-weight: 400;
		    color: #333333;
		}
        .subtSty{
			overflow:hidden;
			　　text-overflow:ellipsis;
			　　white-space:nowrap;
            margin-top:3px;
            font-size: 9px;
            font-weight: 400;
            color: #333333;
        }
        .search{
            width: 57px;
            height: 23px;
            background: linear-gradient(116deg,#36b3fe 11%, #0080ff 91%);
            border-radius: 12px;font-size:14px;color:#fff;text-align:center;
            line-height:23px;
        }
        .blkps{
            position:absolute;
            top:35px;
            right:0px;
            width:142px;
            height:90px;
        }
        .blkrect{
            width: 20px;
            height: 2px;
            background: #ffffff;
        }
        .txtku1{
            margin:4px 0 10px 0;
            font-size: 20px;
            font-weight: 800;
            text-align: left;
            color: #ffffff;
        }
        .txtku2{
            font-size: 16px;
            font-weight: 400;
            color: rgba(255,255,255,0.80);
        }
		/deep/ .van-icon::before {
		    display: inline-block;
		    color: #0080ff;
		    font-size: 40px;
		}
		.uRect{
			position:absolute;top:20px;right:13px;
			width:31px;
			height:25px;
			line-height:25px;
			text-align:center;
			border-radius:25px;
			border: 1px solid #0080ff;
			color:#0080ff;
		}
</style>
